import { API_INTERNAL_ENDPOINT } from './constants'
import { type schemaType } from './schema'

export type returnType = ApiServerResponse<schemaType>

export default async (): Promise<returnType> => {
  const runtimeConfig = useRuntimeConfig()

  const url = `${runtimeConfig.public.NUXT_API_CONTENT_ROOT_URL}/${API_INTERNAL_ENDPOINT}`

  const { data } = await useFetch(url, {
    method: 'POST',
  })

  return data.value as returnType
}
